




































































































import Vue from 'vue'
import { BlockElInterface, ActionInterface, BarBlockPart } from '@/config/interfaces'

export default Vue.extend({
  name: 'BlockEl',
  props: {
    templateItemData: {
      type: Object as () => BlockElInterface,
      required: true
    }
  },
  computed: {
    headerStyle (): string {
      const header = this.templateItemData.header
      return 'background: ' + header.backgroundColor + '; color: ' + header.textColor + ';'
    }
  },
  methods: {
    handleActionClick (action: ActionInterface): void {
      if (action.uri !== undefined) {
        this.getView(action.view, action.content || action.uri, null, action.jumpOnCloseUri)
      }
    },
    separatorStyle (color: string): string {
      return 'border-bottom: 2px solid ' + color + ';'
    },
    leftBarPartStyle (part: BarBlockPart): string {
      const width = (100 * part.val) / part.maxVal
      return 'background: ' + part.barColor + '; width: ' + width + '%;'
    },
    rightBarPartStyle (part: BarBlockPart): string {
      const width = (100 * part.val) / part.maxVal
      return 'width: ' + (100 - width) + '%;'
    },
    stripeStyle (part: BarBlockPart): string {
      const width = (100 * part.stripeVal) / part.maxVal
      return 'width: ' + width + '%;'
    }
  }
})
